module.exports = __webpack_public_path__ + "static/media/img-tit.f6becb04.png";